import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "-1 -5 65 65",
  fill: "#fff",
  "fill-rule": "evenodd",
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  width: "300",
  height: "300",
  "text-anchor": "middle"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("use", {
      "xlink:href": "#A",
      x: "1",
      y: "1"
    }, null, -1),
    _createElementVNode("symbol", {
      id: "A",
      overflow: "visible"
    }, [
      _createElementVNode("path", {
        d: "M39.734 7.524L30.268 26.6 46.934 45.9 16 49.42l48 .5zM37.866 0L16.134 18.186 0 45.406l13.734-1.4z",
        stroke: "none",
        fill: "#035bda"
      })
    ], -1)
  ]))]))
}
export default { render: render }